<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <!-- huidige pagina btnShowChangeTArgetPeriodScreen nu in: If Not Page.IsPostBack Then -->
        <button
          type="button"
          id="btnShowChangeTArgetPeriodScreen"
          class="btn btn-default btn-xs HideForMobileApp"
          @click.prevent="btnShowChangeTArgetPeriodScreen"
          v-if="labels.btnShowChangeTargetPeriodScreen_Visible === 1"
        >
          <font-awesome-icon :icon="['far', 'edit']" />
          {{ translation(7493) }}
        </button>
      </template>
    </XVactionbar>
    <!-- om de loader te testen: statusTargetberekening === 1 -> 0 van maken, en bij 0 -> 1 van maken.  -->
    <div v-if="statusTargetberekening === 1">
      <XVwaiter :text="translation(15206)"></XVwaiter>
    </div>
    <div v-if="statusTargetberekening === 0">
      <div class="row">
        <div class="col-md-12">
          <span id="lblTitel" class="titel">{{ translation(8772) }}</span>
        </div>
      </div>
      <div
        id="pnlTabLinksDossier"
        class="pnlInfoActiviteit tabLinksDossier"
        v-if="labels.hypActiviteiten_NavigateUrl !== null || labels.hypMutatie_NavigateUrl !== null"
      >
        <div class="row visibileTab1">
          <div class="col-md-12">
            <!-- hypStatusoverzicht -->
            <font-awesome-icon :icon="['fa', 'location-arrow']" class="fa-rotate-45" />
            &nbsp;
            {{ translation(2258) }}
          </div>
        </div>
        <div class="row visibileTab2" v-if="labels.hypActiviteiten_NavigateUrl !== null">
          <div class="col-md-12">
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
            <router-link to="Spe021PrPeActiviteiten" v-if="labels.intSettingDialog === 3">{{
              translation(9181)
            }}</router-link>
            <router-link to="Spe021PrPeActiviteiten" v-if="labels.intSettingDialog !== 3">{{
              translation(2259)
            }}</router-link>
          </div>
        </div>
        <div class="row visibileTab3" v-if="labels.hypMutatie_NavigateUrl !== null">
          <div class="col-md-12">
            <!-- hypMutatie -->
            <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
            <a :href="labels.hypMutatie_NavigateUrl">{{ translation(2260) }}</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <XVgraphcontrol :graphdata="graphdata" @graphClick="graphClick"></XVgraphcontrol>
        </div>
      </div>
      <div class="row margin20 lblinfo">
        <div class="col-md-12">
          <p v-html="labels.lblBeschrijving_Text" v-if="allTargets.length >= 1"></p>
          <p v-if="allTargets.length === 0">{{ translation(1232) }}</p>
        </div>
      </div>
      <div class="flex-container">
        <div class="target-item target-header" v-if="showheader">
          <div class="targetbox-content">
            {{ translation(18212) }}
            <span></span>
          </div>
        </div>
        <XVtarget
          v-for="(target, index) in allTargets"
          :key="index"
          v-bind="target"
          :toggle="setToggleTargetRow"
          :intSettingExpandForLinks="labels.intSettingExpandForLinks"
          :togglegrouprow="setTogglegrouprow"
        ></XVtarget>
      </div>
    </div>
  </div>
</template>
<script>
import { FAMixin } from 'pevueglobal'
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import locStore from 'store2'
export default {
  mixins: [FAMixin],
  data: function() {
    return {}
  },
  created() {},
  mounted: async function() {
    this.getTexten()
    await this.getTargets()
    this.stopLoading()
    // this.lstore = locStore.namespace('Spe020PrStatusoverzicht')
  },
  computed: {
    ...mapGetters('Spe020PrStatusoverzicht', [
      'labels',
      'allTargets',
      'targetgroup',
      'statusTargetberekening',
      'showheader',
      'graphdata'
    ])
  },
  methods: {
    ...mapActions('Spe020PrStatusoverzicht', ['getTargets', 'getGraphUrl', 'getTexten']),
    ...mapMutations('Spe020PrStatusoverzicht', ['setToggleTargetRow', 'setTogglegrouprow', 'resetreportstatus']),
    btnShowChangeTArgetPeriodScreen: function() {
      window.location = this.labels.btnShowChangeTArgetPeriodScreen_NavigateUrl
    },
    graphClick: function(graphClickinfo) {
      const graphGetUrlinputApi = {
        pagename: 'SPE020_PR_Statusoverzicht.aspx',
        clientid: '',
        filters: [
          {
            key: 'PersonID',
            value: this.allTargets[0].tblpersonid
          }
        ],
        graphIDForUrl: graphClickinfo.graphID,
        defaultfilter: ''
      }
      this.getGraphUrl({ graphGetUrlinputApi: graphGetUrlinputApi, graphShowInPopup: graphClickinfo.graphShowInPopup })
    }
  }
}
</script>
<style>
.tabLinksDossier a:hover {
  background-image: none;
  padding-left: 0;
}
.flex-container {
  border: 1px solid #c7c7c7;
}
</style>
